export function progressChartBox(chart) {
  const chartHolder = document.createElement("div");
  chartHolder.classList.add("progress-chart-list");
  const progressChartsContainer = document.createElement("div");
  progressChartsContainer.classList.add("progress-charts-container");
  chartHolder.appendChild(progressChartsContainer);

  for (const set of chart.sets) {
    const progressChart = document.createElement("div");
    progressChart.classList.add("progress-chart");
    progressChartsContainer.appendChild(progressChart);

    if (set.label) {
      const progressChartTitle = document.createElement("h3");
      progressChartTitle.classList.add("progress-chart-title");
      progressChartTitle.textContent = set.label;
      progressChart.appendChild(progressChartTitle);
    }

    const progressChartValue = document.createElement("h3");
    progressChartValue.classList.add("progress-chart-value");

    if ("valueFormatted" in set) {
      progressChartValue.textContent = set.valueFormatted;
    } else {
      progressChartValue.textContent = set.value + "%";
    }

    progressChart.appendChild(progressChartValue);

    if (!set.label) {
      progressChartValue.classList.add("big");
    }

    const progressChartBar = document.createElement("div");
    progressChartBar.classList.add("progress-chart-bar");
    progressChart.appendChild(progressChartBar);
    const progressChartBarFill = document.createElement("div");
    progressChartBarFill.classList.add("progress-chart-bar-fill");
    progressChartBarFill.style.width = Math.min(set.value, 100) + "%";
    progressChartBarFill.style.background = set.color;
    progressChartBar.appendChild(progressChartBarFill);

    if (set.details) {
      const progressChartDetails = document.createElement("p");
      progressChartDetails.classList.add("progress-chart-details");
      progressChartDetails.textContent = set.details;
      progressChart.appendChild(progressChartDetails);
    }
  }

  return chartHolder;
}